<template>
  <!--Deve atender todos os forms necessários para Transporte -->

  <div v-if="objDTO !== null && currentAvisoId != 0">
    <div v-show="stage === 1">
      <div class="container">
        <div v-if="stage == 1" class="white-frame">
          <div class="title-text mb-3">
            <b>Dados do Corretor</b>
          </div>
          <div class="row g-3">
            <div class="col-md-6">
              <label class="form-label" for="CorretorContactoNome">Corretor</label>
              <InputText
                id="CorretorContactoNome"
                name="CorretorContactoNome"
                :value="objDTO.CorretorContacto.Nome"
                readonly="readonly"
                class="form-control"
              />
            </div>
            <div
              class="col-md-6"
              :class="{
                'field-required': $v.objDTO.CorretorContacto.Email.$invalid
              }"
            >
              <label class="form-label" for="CorretorContactoEmail">E-mail do corretor</label>
              <InputText
                id="CorretorContactoEmail"
                v-model="objDTO.CorretorContacto.Email"
                name="CorretorContactoEmail"
                class="form-control"
              />
            </div>
            <div
              class="col-md-6"
              :class="{
                'field-required': $v.objDTO.CorretorContacto.Telefone.$invalid
              }"
            >
              <label class="form-label" for="CorretorContactoTelefone">Telefone do corretor</label>
              <mask-input
                id="CorretorContactoTelefone"
                v-model="objDTO.CorretorContacto.Telefone"
                name="CorretorContactoTelefone"
                type="text"
                class="form-control p-inputtext p-component"
                :mask="MASKS.telemovel"
                :unmask="true"
              />
            </div>
          </div>
        </div>
      </div>

      <!-- Componente DadosSinistroTransporte comentado temporariamente -->
      <!-- Campo Ramo -->
      <div class="container">
        <div class="white-frame">
          <div class="title-text mb-3">
            <b>Dados do Seguro</b>
          </div>
          <div class="row g-3">
            <div
              class="col-md-6"
              :class="{ 'field-required': $v.objDTO.Sinistro.SinistroRamoId.$invalid }"
            >
              <label class="form-label" for="ramoSeguro">Ramo</label>
              <Dropdown
                id="ramoSeguro"
                v-model="objDTO.Sinistro.SinistroRamoId"
                :options="ramosSeguro"
                option-label="description"
                option-value="id"
                placeholder="Selecione o ramo"
                class="form-control p-0"
                @change="handleRamoChange"
              />
            </div>
          </div>
        </div>
      </div>

      <!-- Dados da Apólice - Campos obrigatórios -->
      <div class="container">
        <div class="white-frame">
          <div class="title-text mb-3">
            <b>Dados da Apólice</b>
          </div>
          <div v-if="!loading.apoliceData" class="row g-3">
            <!-- Unidade de Risco -->
            <div
              class="col-md-12 mb-3"
              :class="{ 'field-required': $v.objDTO.Apolice.UnidadeDeRiscoExternalId.$invalid }"
            >
              <label class="form-label" for="unidadeRisco">Unidade de Risco</label>
              <Dropdown
                id="unidadeRisco"
                v-model="objDTO.Apolice.UnidadeDeRiscoExternalId"
                :options="riskUnits"
                option-label="Description"
                option-value="RiskUnitId"
                placeholder="Selecione a unidade de risco"
                class="form-control p-0"
                @change="handleRiskUnitChange"
              />
            </div>

            <!-- Objeto Segurado -->
            <div
              class="col-md-12 mb-3"
              :class="{ 'field-required': $v.objDTO.Apolice.ObjectoSeguradoExternalId.$invalid }"
            >
              <label class="form-label" for="objetoSegurado">Objeto Segurado</label>
              <Dropdown
                id="objetoSegurado"
                v-model="objDTO.Apolice.ObjectoSeguradoExternalId"
                :options="insuranceObjects"
                option-label="Description"
                option-value="InsuranceObjectId"
                placeholder="Selecione o objeto segurado"
                class="form-control p-0"
                @change="handleInsuranceObjectChange"
              />
            </div>

            <!-- Cobertura -->
            <div
              class="col-md-12"
              :class="{ 'field-required': $v.objDTO.Apolice.ApoliceCoberturaId.$invalid }"
            >
              <label class="form-label" for="cobertura">Cobertura</label>
              <Dropdown
                id="cobertura"
                v-model="objDTO.Apolice.ApoliceCoberturaId"
                :options="coverages"
                option-label="Description"
                option-value="CoverageId"
                placeholder="Selecione a cobertura"
                class="form-control p-0"
                @change="handleCoberturaDropdownSelection"
              />
            </div>
          </div>
          <LoadingStateFS v-else />
        </div>
      </div>

      <DadosSinistroTransporte
        :validation="$v"
        :events="events"
        :is-loading-events="events.length === 0"
        :show-country-selector="true"
        :is-loading-data="loading.apoliceData"
        :is-brasil-selected="isBrasilSinistroSelected"
        @naturezaChanged="handleCoverageChange"
      />

      <!-- Componente específico para Coberturas e Eventos -->
      <div class="container">
        <div class="white-frame">
          <div class="title-text mb-3">
            <b>Natureza do Sinistro</b>
          </div>
          <div v-if="!loading.apoliceData">
            <!-- Apenas o campo de Natureza do Sinistro (Evento) -->
            <div class="row g-3">
              <div
                class="col-md-12"
                :class="{
                  'field-required':
                    $v &&
                    $v.objDTO &&
                    $v.objDTO.Sinistro &&
                    $v.objDTO.Sinistro.SinistroNaturezaEventoId &&
                    $v.objDTO.Sinistro.SinistroNaturezaEventoId.$invalid
                }"
              >
                <label class="form-label" for="evento">Natureza</label>
                <Dropdown
                  id="evento"
                  v-model="objDTO.Sinistro.SinistroNaturezaEventoId"
                  :placeholder="
                    events.length === 0 ? 'Carregando...' : 'Selecione a natureza do sinistro'
                  "
                  :options="events"
                  option-label="Description"
                  option-value="Id"
                  data-key="Id"
                  :show-clear="true"
                  :filter="true"
                  :loading="events.length === 0"
                  class="form-control"
                  :disabled="events.length === 0"
                  @change="onNaturezaChange"
                />
              </div>
            </div>
          </div>
          <LoadingStateFS v-else />
        </div>
      </div>

      <!-- Componente de Dados de Embarque -->
      <DadosEmbarque
        :validation="$v"
        :is-loading-data="loading.apoliceData"
        :is-brasil-selected="isBrasilEmbarqueSelected"
      />

      <!-- Componente de Dados do Transporte -->
      <div v-if="objDTO && objDTO.Transporte" class="container">
        <div class="white-frame">
          <div class="title-text mb-3">
            <b>Dados do Transporte</b>
          </div>

          <!-- Dados do Motorista -->
          <div v-if="objDTO && objDTO.Transporte && objDTO.Transporte.Motorista" class="row g-3">
            <div
              class="col-md-6"
              :class="{ 'field-required': isInvalid('objDTO.Transporte.Motorista.Nome') }"
            >
              <label class="form-label" for="motoristaNome">Nome do Motorista</label>
              <InputText
                id="motoristaNome"
                v-model="objDTO.Transporte.Motorista.Nome"
                class="form-control"
              />
            </div>
            <div
              class="col-md-6"
              :class="{ 'field-required': isInvalid('objDTO.Transporte.Motorista.Telefone') }"
            >
              <label class="form-label" for="motoristaTelefone">Telefone do Motorista</label>
              <mask-input
                id="motoristaTelefone"
                v-model="objDTO.Transporte.Motorista.Telefone"
                type="text"
                class="form-control p-inputtext p-component"
                :mask="MASKS.telemovel"
                :unmask="true"
              />
            </div>
          </div>

          <div v-if="objDTO.Transporte.Motorista" class="row g-3 mt-2">
            <div
              class="col-md-6"
              :class="{ 'field-required': isInvalid('objDTO.Transporte.Motorista.CPF') }"
            >
              <label class="form-label" for="motoristaCpf">CPF do Motorista</label>
              <mask-input
                id="motoristaCpf"
                v-model="objDTO.Transporte.Motorista.CPF"
                type="text"
                class="form-control p-inputtext p-component"
                mask="000.000.000-00"
                :unmask="true"
              />
            </div>
            <div class="col-md-6">
              <label class="form-label" for="motoristaCnh">CNH do Motorista</label>
              <InputText
                id="motoristaCnh"
                v-model="objDTO.Transporte.Motorista.CNH"
                class="form-control"
              />
            </div>
          </div>

          <!-- Dados do Veículo -->
          <div v-if="objDTO && objDTO.Transporte && objDTO.Transporte.Veiculo" class="row g-3 mt-3">
            <div
              class="col-md-4"
              :class="{ 'field-required': isInvalid('objDTO.Transporte.Veiculo.Placa') }"
            >
              <label class="form-label" for="veiculoPlaca">Placa do Veículo</label>
              <InputText
                id="veiculoPlaca"
                v-model="objDTO.Transporte.Veiculo.Placa"
                class="form-control"
              />
            </div>
            <div
              class="col-md-4"
              :class="{ 'field-required': isInvalid('objDTO.Transporte.Veiculo.Marca') }"
            >
              <label class="form-label" for="veiculoMarca">Marca do Veículo</label>
              <InputText
                id="veiculoMarca"
                v-model="objDTO.Transporte.Veiculo.Marca"
                class="form-control"
              />
            </div>
            <div
              class="col-md-4"
              :class="{ 'field-required': isInvalid('objDTO.Transporte.Veiculo.Modelo') }"
            >
              <label class="form-label" for="veiculoModelo">Modelo do Veículo</label>
              <InputText
                id="veiculoModelo"
                v-model="objDTO.Transporte.Veiculo.Modelo"
                class="form-control"
              />
            </div>
          </div>

          <!-- Dados de Rastreamento -->
          <div class="row g-3 mt-3">
            <div class="col-md-12">
              <div class="form-check">
                <input
                  id="possuiRastreador"
                  v-model="objDTO.Transporte.PossuiRastreador"
                  class="form-check-input"
                  type="checkbox"
                />
                <label class="form-check-label" for="possuiRastreador"> Veículo Rastreado? </label>
              </div>
            </div>
          </div>

          <div
            v-if="objDTO && objDTO.Transporte && objDTO.Transporte.PossuiRastreador"
            class="row g-3 mt-2"
          >
            <div
              class="col-md-6"
              :class="{ 'field-required': isInvalid('objDTO.Transporte.EmpresaRastreamento') }"
            >
              <label class="form-label" for="empresaRastreamento">Empresa de Rastreamento</label>
              <InputText
                id="empresaRastreamento"
                v-model="objDTO.Transporte.EmpresaRastreamento"
                class="form-control"
              />
            </div>
            <div class="col-md-6">
              <label class="form-label" for="telefoneRastreamento">Telefone de Rastreamento</label>
              <mask-input
                id="telefoneRastreamento"
                v-model="objDTO.Transporte.TelefoneRastreamento"
                type="text"
                class="form-control p-inputtext p-component"
                :mask="MASKS.telemovel"
                :unmask="true"
              />
            </div>
          </div>

          <!-- Tipo de Equipamento -->
          <div class="row g-3 mt-3">
            <div class="col-md-6">
              <label class="form-label" for="tipoEquipamento">Tipo de Equipamento</label>
              <Dropdown
                id="tipoEquipamento"
                v-model="objDTO.Transporte.TipoEquipamento"
                :options="tiposEquipamento"
                option-label="description"
                option-value="id"
                placeholder="Selecione o tipo de equipamento"
                class="form-control p-0"
              />
            </div>
            <div class="col-md-6">
              <div class="form-check mt-4">
                <input
                  id="veiculoLocalizado"
                  v-model="objDTO.Transporte.VeiculoLocalizado"
                  class="form-check-input"
                  type="checkbox"
                />
                <label class="form-check-label" for="veiculoLocalizado">
                  Veículo Localizado?
                </label>
              </div>
            </div>
          </div>

          <!-- Gerenciadora de Risco -->
          <div
            v-if="objDTO && objDTO.Transporte && objDTO.Transporte.VeiculoLocalizado"
            class="row g-3 mt-2"
          >
            <div
              class="col-md-6"
              :class="{ 'field-required': isInvalid('objDTO.Transporte.GerenciadoraRisco') }"
            >
              <label class="form-label" for="gerenciadoraRisco">Gerenciadora de Risco</label>
              <InputText
                id="gerenciadoraRisco"
                v-model="objDTO.Transporte.GerenciadoraRisco"
                class="form-control"
              />
            </div>
            <div class="col-md-6">
              <label class="form-label" for="numeroLiberacao">Nº da Liberação</label>
              <InputText
                id="numeroLiberacao"
                v-model="objDTO.Transporte.NumeroLiberacao"
                class="form-control"
              />
            </div>
          </div>

          <!-- Boletim de Ocorrência -->
          <div class="row g-3 mt-3">
            <div class="col-md-12">
              <div class="form-check">
                <input
                  id="possuiBO"
                  v-model="objDTO.Transporte.PossuiBO"
                  class="form-check-input"
                  type="checkbox"
                />
                <label class="form-check-label" for="possuiBO">
                  Possui Boletim de Ocorrência?
                </label>
              </div>
            </div>
          </div>

          <div
            v-if="objDTO && objDTO.Transporte && objDTO.Transporte.PossuiBO"
            class="row g-3 mt-2"
          >
            <div
              class="col-md-6"
              :class="{ 'field-required': isInvalid('objDTO.Transporte.NumeroBO') }"
            >
              <label class="form-label" for="numeroBO">Nº do Boletim de Ocorrência</label>
              <InputText id="numeroBO" v-model="objDTO.Transporte.NumeroBO" class="form-control" />
            </div>
            <div
              class="col-md-6"
              :class="{ 'field-required': isInvalid('objDTO.Transporte.DataBO') }"
            >
              <label class="form-label" for="dataBO">Data do BO</label>
              <Calendar
                id="dataBO"
                v-model="objDTO.Transporte.DataBO"
                :show-icon="true"
                date-format="dd/mm/yy"
                class="form-control p-0"
                :manual-input="true"
              />
            </div>
          </div>

          <div
            v-if="objDTO && objDTO.Transporte && objDTO.Transporte.PossuiBO"
            class="row g-3 mt-2"
          >
            <div class="col-md-6">
              <label class="form-label" for="delegaciaBO">Delegacia</label>
              <InputText
                id="delegaciaBO"
                v-model="objDTO.Transporte.DelegaciaBO"
                class="form-control"
              />
            </div>
            <div class="col-md-6">
              <label class="form-label" for="cidadeBO">Cidade do BO</label>
              <InputText id="cidadeBO" v-model="objDTO.Transporte.CidadeBO" class="form-control" />
            </div>
          </div>

          <!-- Danos na Mercadoria -->
          <div class="row g-3 mt-3">
            <div class="col-md-12">
              <div class="form-check">
                <input
                  id="possuiDanosMercadoria"
                  v-model="objDTO.Transporte.PossuiDanosMercadoria"
                  class="form-check-input"
                  type="checkbox"
                />
                <label class="form-check-label" for="possuiDanosMercadoria">
                  Possui Danos na Mercadoria?
                </label>
              </div>
            </div>
          </div>

          <div
            v-if="objDTO && objDTO.Transporte && objDTO.Transporte.PossuiDanosMercadoria"
            class="row g-3 mt-2"
          >
            <div class="col-md-6">
              <label class="form-label" for="tipoDanoMercadoria">Tipo de Dano</label>
              <Dropdown
                id="tipoDanoMercadoria"
                v-model="objDTO.Transporte.TipoDanoMercadoria"
                :options="tiposDanoMercadoria"
                option-label="description"
                option-value="id"
                placeholder="Selecione o tipo de dano"
                class="form-control p-0"
              />
            </div>
            <div class="col-md-6">
              <label class="form-label" for="percentualDanoMercadoria">
                Percentual do Dano (%)
              </label>
              <InputNumber
                id="percentualDanoMercadoria"
                v-model="objDTO.Transporte.PercentualDanoMercadoria"
                mode="decimal"
                :min-fraction-digits="2"
                :max-fraction-digits="2"
                suffix="%"
                class="form-control p-0"
              />
            </div>
          </div>

          <div
            v-if="objDTO && objDTO.Transporte && objDTO.Transporte.PossuiDanosMercadoria"
            class="row g-3 mt-2"
          >
            <div class="col-md-12">
              <label class="form-label" for="descricaoDanosMercadoria">Descrição dos Danos</label>
              <Textarea
                id="descricaoDanosMercadoria"
                v-model="objDTO.Transporte.DescricaoDanosMercadoria"
                class="form-control"
                rows="3"
              />
            </div>
          </div>

          <!-- Valor Estimado de Reparação -->
          <div class="row g-3 mt-3">
            <div
              class="col-md-6"
              :class="{ 'field-required': isInvalid('objDTO.Veiculo.ValorEstimadoReparacao') }"
            >
              <label class="form-label" for="valorEstimadoReparacao">Estimativa de Prejuízo</label>
              <InputNumber
                id="valorEstimadoReparacao"
                v-model="objDTO.Veiculo.ValorEstimadoReparacao"
                mode="currency"
                currency="BRL"
                locale="pt-BR"
                class="form-control p-0"
              />
            </div>
          </div>
        </div>
      </div>

      <!-- Componente de Vistoria -->
      <DadosVistoria :validation="$v" :display-botao-replicar="true"></DadosVistoria>

      <div v-if="!$v.objDTO.$invalid" class="container">
        <div class="col-12 Aligner aligner-right mt-4">
          <button class="button-base-small btn-green font-small mx-1" @click="stage = 2">
            Finalizar
          </button>
        </div>
      </div>
    </div>
    <div v-if="stage === 2">
      <ResumeTransporte
        :coverages="coverages"
        :events="events"
        :risk-units="riskUnits"
        :insurance-objects="insuranceObjects"
        :obj-d-t-o="objDTO"
        :mercadorias="[]"
        :tipos-veiculo="[]"
        :tipos-dano="tiposDanoMercadoria"
        @back="v => (stage = v)"
        @submit-aviso="handleSubmitAviso"
      />
    </div>
  </div>
  <LoadingStateFS v-else />
</template>

<script>
  import { mapGetters, mapActions, mapMutations } from 'vuex';
  import {
    getCoverages,
    getEvents,
    getEventsByProductId,
    getFormDataByApoliceProdutoIdAndBranchId,
    getInsuranceObjects,
    getRiskUnits
  } from '../api/formMethods';
  // CORRIGIDO - usar pasta 'transporte' (minúsculo) ao invés de 'Transporte' (maiúsculo)
  import DadosSinistroTransporte from '../components/areaNegocio/transporte/DadosSinistroTransporte.vue';
  import DadosEmbarque from '../components/areaNegocio/transporte/DadosEmbarque.vue';
  import DadosVistoria from '../components/areaNegocio/financial/DadosVistoria.vue';
  import ResumeTransporte from '../components/Resume/ResumeTransporte.vue';
  import { getInfoByOperationPK } from '../utils/helpers';
  import { required, requiredIf, email } from 'vuelidate/lib/validators';
  // Importações mantidas para uso futuro em validações customizadas
  // import { dateAfterToday, inputClean } from '../utils/customValidations';
  import LoadingStateFS from '../components/LoadingStateFS.vue';
  import Swal from 'sweetalert2';
  import { MASKS } from '../utils/constants';
  import { IMaskComponent } from 'vue-imask';
  import InputText from 'primevue/inputtext';
  import Dropdown from 'primevue/dropdown';
  import InputNumber from 'primevue/inputnumber';
  import Calendar from 'primevue/calendar';
  import Textarea from 'primevue/textarea';
  // import axios from 'axios';

  // Constantes
  const BRASIL_PAIS_ID = 3;
  const MAX_INT32 = 2147483647;
  const FORM_NAME = 'Aviso de Sinistro - Transporte';
  const DEFAULT_AVISO_ID = 1;
  // Constante mantida para uso futuro em implementações
  // const DEFAULT_FORM_ID = 13; // FormAvisoId usado no ResumeTransporte

  // Opções para dropdowns
  const RAMOS_SEGURO = [
    { id: 1, description: 'Transporte Nacional' },
    { id: 2, description: 'Transporte Internacional' },
    { id: 3, description: 'Transporte Marítimo' },
    { id: 4, description: 'Transporte Aéreo' },
    { id: 5, description: 'Transporte Terrestre' },
    { id: 6, description: 'Multimodal' }
  ];

  const TIPOS_EQUIPAMENTO = [
    { id: 1, description: 'GPS' },
    { id: 2, description: 'Rastreador Satelital' },
    { id: 3, description: 'Telemetria' },
    { id: 4, description: 'RFID' },
    { id: 5, description: 'Outro' }
  ];

  const TIPOS_DANO_MERCADORIA = [
    { id: 1, description: 'Avaria' },
    { id: 2, description: 'Falta' },
    { id: 3, description: 'Quebra' },
    { id: 4, description: 'Molhadura' },
    { id: 5, description: 'Amassamento' },
    { id: 6, description: 'Contaminação' },
    { id: 7, description: 'Outro' }
  ];

  /**
   * Componente principal de Transporte
   * Gerencia o fluxo de cadastro de avisos de sinistro para a área de Transporte
   *
   * NOTAS SOBRE AVISOS DO LINTER:
   * - O método validations() tem mais de 150 linhas devido à complexidade das regras de validação.
   *   Poderia ser refatorado para usar composição de validadores em arquivos separados.
   *
   * - O método handleRamoChange() tem mais de 50 linhas e complexidade ciclomática > 10.
   *   Poderia ser dividido em submétodos para cada responsabilidade específica.
   */
  export default {
    components: {
      'mask-input': IMaskComponent,
      InputText,
      DadosSinistroTransporte, // CORRIGIDO - case sensitivity resolvido
      DadosEmbarque, // CORRIGIDO - case sensitivity resolvido
      DadosVistoria,
      ResumeTransporte,
      LoadingStateFS,
      Dropdown,
      InputNumber,
      Calendar,
      Textarea
    },
    data() {
      return {
        loading: {
          apoliceData: false,
          events: false,
          coverages: false,
          objectosSegurados: false
        },
        MASKS: MASKS,
        events: [],
        riskUnits: [],
        insuranceObjects: [],
        coverages: [],
        currentAvisoId: 0,
        formName: FORM_NAME,
        stage: 1,
        brasilPaisId: BRASIL_PAIS_ID,
        token: null,
        dataDDLRisksUnitsExecCount: 0,
        dataDDLInsuranceObjectsExecCount: 0,
        dataDDLCoverageExecCount: 0,
        ramosSeguro: RAMOS_SEGURO,
        tiposEquipamento: TIPOS_EQUIPAMENTO,
        tiposDanoMercadoria: TIPOS_DANO_MERCADORIA
      };
    },
    computed: {
      ...mapGetters({ objDTO: 'getObjDTO' }),
      isBrasilSinistroSelected() {
        return (
          this.objDTO &&
          this.objDTO.Sinistro &&
          this.objDTO.Sinistro.SinistroPaisId === this.brasilPaisId
        );
      },
      isBrasilVistoriaSelected() {
        return (
          this.objDTO &&
          this.objDTO.Vistoria &&
          this.objDTO.Vistoria.VistoriaLocal &&
          this.objDTO.Vistoria.VistoriaLocal.PaisId === this.brasilPaisId
        );
      },
      isBrasilEmbarqueSelected() {
        return (
          this.objDTO &&
          this.objDTO.EmbarqueTransporte &&
          this.objDTO.EmbarqueTransporte.PaisOrigem === this.brasilPaisId
        );
      }
    },
    created() {
      // Inicializa a estrutura básica de objDTO se não existir
      if (!this.objDTO) {
        this.$store.commit('setObjDTO', {});
        return;
      }

      this.initializeSinistroData();
      this.initializeTransporteData();
    },
    async mounted() {
      if (!this.objDTO) {
        this.$router.push({ name: 'Home' });
        return;
      }

      this.initializeProcessoGDM();
      this.initializeEmbarqueData();
      this.initializeServico();
      this.initializeVeiculoData();
      this.initializeReservaData();

      this.getOrSetCountries();
      this.getOrSetStatesBrasil();

      // Inicializa o array de eventos para evitar erro de Dropdown
      if (!this.events) {
        this.events = [];
      }

      // Carrega os dados da apólice apenas se houver informações suficientes
      try {
        await this.loadPolicyData();
      } catch (error) {
        console.error('Error in mounted:', error);
      }

      this.initializeSinistroDateTime();

      // Força validação após montar para garantir que o estado esteja correto
      this.$nextTick(() => {
        if (this.$v) {
          this.$v.$touch();
        }
      });
    },
    validations() {
      return {
        objDTO: {
          ProcessoGDM: {
            ProdutoEnvioContacto: {
              Nome: { required }
            },
            ProdutoRecebidoContacto: {
              Morada: {} // Tornando o campo Morada opcional
            }
          },
          EmbarqueTransporte: {
            ValorDeclarado: { required },
            Mercadoria: { required },
            PaisOrigem: {}, // Removida validação obrigatória
            PaisDestino: {}, // Removida validação obrigatória
            // Campos mapeados
            VeiculoLocalizadoOpcaoId: {},
            NrLiberacao: {},
            TipoEquipamento: {}
          },
          Transporte: {
            Motorista: {
              Nome: {},
              Telefone: {},
              CPF: {}
            },
            Veiculo: {
              Placa: {},
              Marca: {},
              Modelo: {}
            },
            EmpresaRastreamento: {
              requiredIf: requiredIf(
                () =>
                  this.objDTO &&
                  this.objDTO.Transporte &&
                  this.objDTO.Transporte.PossuiRastreador === true
              )
            },
            GerenciadoraRisco: {
              requiredIf: requiredIf(
                () =>
                  this.objDTO &&
                  this.objDTO.Transporte &&
                  this.objDTO.Transporte.VeiculoLocalizado === true
              )
            },
            NumeroBO: {
              requiredIf: requiredIf(
                () =>
                  this.objDTO && this.objDTO.Transporte && this.objDTO.Transporte.PossuiBO === true
              )
            },
            DataBO: {
              requiredIf: requiredIf(
                () =>
                  this.objDTO && this.objDTO.Transporte && this.objDTO.Transporte.PossuiBO === true
              )
            }
          },
          Veiculo: {
            ValorEstimadoReparacao: { required }
          },
          CorretorContacto: {
            Email: { email },
            Telefone: { required }
          },
          Apolice: {
            ApoliceCoberturaId: { required },
            UnidadeDeRiscoExternalId: { required },
            ObjectoSeguradoExternalId: { required }
          },
          Sinistro: {
            SinistroRamoId: { required },
            SinistroDataOcorrencia: { required },
            SinistroHoraOcorrencia: {
              required,
              format: function (value) {
                // Valida formato de hora (HH:MM)
                if (!value) {
                  return false;
                }
                return /^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/.test(value);
              }
            },
            SinistroDataAviso: { required },
            SinistroHoraAviso: {
              required,
              format: function (value) {
                // Valida formato de hora (HH:MM)
                if (!value) {
                  return false;
                }
                return /^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/.test(value);
              }
            },
            SinistroMorada: {}, // Campo não obrigatório
            SinistroMoradaNrPorta: {}, // Campo não obrigatório
            SinistroFreguesia: {}, // Campo não obrigatório
            SinistroCidade: {}, // Campo não obrigatório
            SinistroEstado: {}, // Campo não obrigatório
            SinistroPaisId: {}, // Campo não obrigatório
            SinistroNaturezaEventoId: { required },
            SinistroObs: { required }
          },
          Vistoria: {
            VistoriaLocal: {
              Telefone: { required },
              Nome: { required },
              Morada: { required },
              CodPostalLocalidade: { required },
              PaisId: { required },
              PaisDescription: { required },
              DistritoId: {
                requiredIf: requiredIf(
                  () =>
                    this.objDTO &&
                    this.objDTO.Vistoria &&
                    this.objDTO.Vistoria.VistoriaLocal &&
                    this.objDTO.Vistoria.VistoriaLocal.PaisId === this.brasilPaisId
                )
              },
              DistritoDescription: { required },
              ConcelhoId: {
                requiredIf: requiredIf(
                  () =>
                    this.objDTO &&
                    this.objDTO.Vistoria &&
                    this.objDTO.Vistoria.VistoriaLocal &&
                    this.objDTO.Vistoria.VistoriaLocal.PaisId === this.brasilPaisId &&
                    this.objDTO.Vistoria.VistoriaLocal.DistritoId
                )
              },
              ConcelhoDescription: { required },
              FreguesiaId: {
                requiredIf: requiredIf(
                  () =>
                    this.objDTO &&
                    this.objDTO.Vistoria &&
                    this.objDTO.Vistoria.VistoriaLocal &&
                    this.objDTO.Vistoria.VistoriaLocal.PaisId === this.brasilPaisId &&
                    this.objDTO.Vistoria.VistoriaLocal.ConcelhoId
                )
              },
              FreguesiaDescription: { required }
            }
          }
        }
      };
    },
    methods: {
      ...mapMutations(['setLocalVistoria']),
      ...mapActions(['getOrSetCountries', 'getOrSetStatesBrasil']),

      /**
       * Inicializa os dados básicos de sinistro
       */
      initializeSinistroData() {
        // Inicializa o Ramo se não existir
        if (!this.objDTO.Sinistro) {
          this.$store.commit('setObjDTO', {
            ...this.objDTO,
            Sinistro: {
              SinistroRamoId: null
            }
          });
        } else if (this.objDTO.Sinistro && this.objDTO.Sinistro.SinistroRamoId === undefined) {
          this.$store.commit('setObjDTO', {
            ...this.objDTO,
            Sinistro: {
              ...this.objDTO.Sinistro,
              SinistroRamoId: null
            }
          });
        }

        // Garantir que o objeto Sinistro esteja corretamente inicializado
        if (!this.objDTO.Sinistro) {
          this.objDTO.Sinistro = {};
        }

        // Inicializar o campo de natureza do sinistro se não estiver definido
        if (
          this.objDTO.Sinistro.SinistroNaturezaEventoId === undefined ||
          this.objDTO.Sinistro.SinistroNaturezaEventoId === null
        ) {
          this.$set(this.objDTO.Sinistro, 'SinistroNaturezaEventoId', '');
        }
      },

      /**
       * Inicializa os dados de data e hora do sinistro
       */
      initializeSinistroDateTime() {
        // Inicializa campos de data e hora do aviso, que são requeridos pela validação
        if (this.objDTO.Sinistro) {
          if (!this.objDTO.Sinistro.SinistroDataAviso) {
            this.objDTO.Sinistro.SinistroDataAviso = new Date();
          }
          if (!this.objDTO.Sinistro.SinistroHoraAviso) {
            const now = new Date();
            this.objDTO.Sinistro.SinistroHoraAviso = `${String(now.getHours()).padStart(
              2,
              '0'
            )}:${String(now.getMinutes()).padStart(2, '0')}`;
          }
        }
      },

      /**
       * Inicializa a estrutura para os dados do transporte
       */
      initializeTransporteData() {
        if (!this.objDTO.Transporte) {
          this.$store.commit('setObjDTO', {
            ...this.objDTO,
            Transporte: {
              Motorista: {
                Nome: null,
                Telefone: null,
                CPF: null,
                CNH: null
              },
              Veiculo: {
                Placa: null,
                Marca: null,
                Modelo: null,
                Descricao: null
              },
              PossuiRastreador: false,
              EmpresaRastreamento: null,
              TelefoneRastreamento: null,
              TipoEquipamento: null,
              VeiculoLocalizado: false,
              GerenciadoraRisco: null,
              NumeroLiberacao: null,
              PossuiBO: false,
              NumeroBO: null,
              DataBO: null,
              DelegaciaBO: null,
              CidadeBO: null,
              PossuiDanosMercadoria: false,
              TipoDanoMercadoria: null,
              PercentualDanoMercadoria: null,
              DescricaoDanosMercadoria: null
            },
            Veiculo: {
              ValorEstimadoReparacao: null
            }
          });
        }
      },

      /**
       * Inicializa estrutura de ProcessoGDM (Contém dados de remetente e destinatário)
       */
      initializeProcessoGDM() {
        if (!this.objDTO.ProcessoGDM) {
          this.objDTO.ProcessoGDM = {
            ProdutoEnvioContacto: {
              Nome: '',
              Telefone: '',
              Email: '',
              Morada: '',
              MoradaNrPorta: '',
              PaisId: null,
              DistritoId: null,
              ConcelhoId: null,
              FreguesiaId: null
            },
            ProdutoRecebidoContacto: {
              Nome: '',
              Morada: '',
              Telefone: '',
              Email: '',
              MoradaNrPorta: '',
              PaisId: null,
              DistritoId: null,
              ConcelhoId: null,
              FreguesiaId: null
            }
          };
        }
      },

      /**
       * Inicializa estrutura de dados de Embarque (Específica para Transporte)
       */
      initializeEmbarqueData() {
        if (!this.objDTO.EmbarqueTransporte) {
          this.objDTO.EmbarqueTransporte = {
            // Não duplicar contatos de remetente/destinatário aqui, pois estão no ProcessoGDM
            ValorDeclarado: 0,
            FaturaNr: '',
            NumeroConhecimento: '',
            Manifesto: '',
            DataEmbarque: null,
            // Campos extras mapeados no frontend
            Mercadoria: null,
            PaisOrigem: null,
            EstadoOrigem: null,
            CidadeOrigem: null,
            PaisDestino: null,
            EstadoDestino: null,
            CidadeDestino: null,
            TipoEquipamento: null,
            VeiculoLocalizadoOpcaoId: null,
            NrLiberacao: '',
            // Campos para mapeamento com a DTO
            RastreadoOpcaoId: null,
            Matricula: ''
          };
        }
      },

      /**
       * Inicializa objeto serviço (para o componente DadosComunicante)
       */
      initializeServico() {
        // Inicializa serviço (para o componente DadosComunicante)
        if (!this.objDTO.Servico) {
          this.objDTO.Servico = {
            ServicoComplementoPeriodoDiaId: null
          };
        }
      },

      /**
       * Inicializa dados do veículo
       */
      initializeVeiculoData() {
        // Inicializa valor estimado de reparação caso não exista
        if (!this.objDTO.Veiculo) {
          this.objDTO.Veiculo = {};
        }

        // Garante que o valor seja inicializado como número
        this.objDTO.Veiculo.ValorEstimadoReparacao =
          this.objDTO.Veiculo.ValorEstimadoReparacao !== undefined &&
          this.objDTO.Veiculo.ValorEstimadoReparacao !== null
            ? parseFloat(this.objDTO.Veiculo.ValorEstimadoReparacao)
            : 0;
      },

      /**
       * Inicializa dados de reserva
       */
      initializeReservaData() {
        // Inicializa objeto Reserva caso não exista
        if (!this.objDTO.Reserva) {
          this.objDTO.Reserva = {};
        }

        // Garante que o valor reclamado seja inicializado como número
        this.objDTO.Reserva.ValorReclamado =
          this.objDTO.Reserva.ValorReclamado !== undefined &&
          this.objDTO.Reserva.ValorReclamado !== null
            ? parseFloat(this.objDTO.Reserva.ValorReclamado)
            : 0;
      },

      /**
       * Carrega dados da apólice e eventos associados
       */
      async loadPolicyData() {
        if (this.$route.query.operationPK) {
          const operationPK = this.$route.query.operationPK;
          await this.policySelected(operationPK);
        } else if (this.objDTO.Apolice && this.objDTO.Apolice.ApoliceContrato) {
          await this.policySelected(this.objDTO.Apolice.ApoliceContrato);
        } else {
          // Carrega eventos genéricos se possível
          await this.loadGenericEvents();
        }
      },

      /**
       * Carrega eventos genéricos quando não há dados específicos da apólice
       */
      async loadGenericEvents() {
        if (!this.events || this.events.length === 0) {
          try {
            const eventos = await getEvents();
            // Garante que eventos seja um array
            if (eventos) {
              if (Array.isArray(eventos)) {
                this.events = eventos;

                // Se há eventos e nenhuma Natureza selecionada, seleciona o primeiro
                if (this.events.length > 0 && !this.objDTO.Sinistro.SinistroNaturezaEventoId) {
                  this.objDTO.Sinistro.SinistroNaturezaEventoId = this.events[0].Id;
                  // Força validação após selecionar
                  this.$nextTick(() => {
                    if (this.$v && this.$v.objDTO && this.$v.objDTO.Sinistro) {
                      this.$v.$touch();
                    }
                  });
                }
              } else {
                console.warn('Eventos não é um array, convertendo');
                this.events = Array.isArray(eventos) ? eventos : [];
              }
            }
          } catch (error) {
            console.error('Erro ao carregar eventos genéricos:', error);
            this.events = [];
          }
        }
      },

      /**
       * Trata a submissão do aviso pelo usuário
       * @param {Object} payload - Dados do formulário a serem enviados
       */
      async handleSubmitAviso(payload) {
        try {
          console.log('Recebido evento submit-aviso com payload:', payload);
          const response = await this.submitAviso(payload);

          if (response && response.avisoNumber) {
            Swal.fire({
              title: 'Sucesso!',
              text: `Aviso criado com sucesso. Número do aviso: ${response.avisoNumber}`,
              icon: 'success',
              confirmButtonText: 'Ok'
            }).then(() => {
              this.$router.push({ name: 'Home' });
            });
          } else {
            // Resposta existe mas sem número do aviso
            Swal.fire({
              title: 'Sucesso!',
              text: 'Aviso criado com sucesso.',
              icon: 'success',
              confirmButtonText: 'Ok'
            }).then(() => {
              this.$router.push({ name: 'Home' });
            });
          }
        } catch (error) {
          console.error('Erro ao processar submissão do aviso:', error);

          Swal.fire({
            title: 'Erro',
            text: 'Ocorreu um erro ao criar o aviso. Por favor, tente novamente.',
            icon: 'error',
            confirmButtonText: 'Ok'
          });
        }
      },

      /**
       * Trata a mudança de ramo de seguro, atualizando dados dependentes
       */
      async handleRamoChange() {
        // Limpar dados dependentes do ramo
        this.objDTO.Apolice.UnidadeDeRiscoExternalId = null;
        this.objDTO.Apolice.ObjectoSeguradoExternalId = null;
        this.objDTO.Apolice.ApoliceCoberturaId = null;
        this.objDTO.Sinistro.SinistroEventoId = null;

        // Resetar listas dependentes
        this.riskUnits = [];
        this.insuranceObjects = [];
        this.coverages = [];
        this.events = [];

        // Carregar dados específicos do ramo, se necessário
        if (this.objDTO.Sinistro.SinistroRamoId) {
          this.loading.apoliceData = true;

          try {
            // Carrega eventos para o ramo selecionado
            try {
              const eventos = await getEvents(
                this.objDTO.Apolice.ApoliceProdutoId,
                null,
                this.objDTO.Sinistro.SinistroRamoId
              );

              if (eventos && Array.isArray(eventos)) {
                this.events = eventos;
              }
            } catch (error) {
              this.trataErro(error, 'carregar eventos', {
                ramoId: this.objDTO.Sinistro.SinistroRamoId,
                apoliceProdutoId: this.objDTO.Apolice.ApoliceProdutoId
              });
            }

            // Se tiver um contrato de apólice, tenta obter as unidades de risco
            if (this.objDTO.Apolice && this.objDTO.Apolice.ApoliceContrato) {
              try {
                const riskUnits = await getRiskUnits(this.objDTO.Apolice.ApoliceContrato);
                if (riskUnits && Array.isArray(riskUnits)) {
                  this.riskUnits = riskUnits;
                }
              } catch (error) {
                this.trataErro(error, 'carregar unidades de risco', {
                  apoliceContrato: this.objDTO.Apolice.ApoliceContrato
                });
              }
            }
          } catch (error) {
            this.trataErro(
              error,
              'processar mudança de ramo',
              {
                ramoId: this.objDTO.Sinistro.SinistroRamoId
              },
              true
            );
          } finally {
            this.loading.apoliceData = false;
          }
        }
      },

      /**
       * Método auxiliar para verificar validação de forma segura
       * @param {string} path - Caminho do campo no objeto de validação (ex: "objDTO.Transporte.Motorista.Nome")
       * @returns {boolean} - Verdadeiro se o campo for inválido
       */
      isInvalid(path) {
        if (!this.$v) {
          return false;
        }

        // Divide o caminho em partes, ex: "objDTO.Transporte.Motorista.Nome"
        const parts = path.split('.');
        let current = this.$v;

        // Percorre o caminho para verificar se cada parte existe
        for (const part of parts) {
          if (!current[part]) {
            return false;
          }
          current = current[part];
        }

        // Verifica se existe a propriedade $invalid
        return current.$invalid === true;
      },

      /**
       * Trata a mudança de vínculo do comunicante
       * @param {Object} comunicante - Dados do comunicante selecionado
       */
      handleVinculoChange(comunicante) {
        console.log('Vínculo alterado:', comunicante);
        // Atualiza os dados do comunicante se necessário
      },

      /**
       * Replica os dados do sinistro para a vistoria
       * Copia endereço e informações de contato
       */
      replicarVistoria() {
        this.setLocalVistoria({
          Morada: this.objDTO.Sinistro.SinistroMorada,
          Telefone: this.objDTO.Sinistro.SinistroTelemovel || '',
          Nome: this.objDTO.Sinistro.SinistroNome || '',
          CodPostalLocalidade: this.objDTO.Sinistro.SinistroMoradaNrPorta || '',
          PaisId: this.objDTO.Sinistro.SinistroPaisId,
          PaisDescription: this.objDTO.Sinistro.SinistroPaisDescricao,
          DistritoId: this.objDTO.Sinistro.SinistroDistritoId,
          DistritoDescription: this.objDTO.Sinistro.SinistroDistritoDescripton,
          ConcelhoId: this.objDTO.Sinistro.SinistroConcelhoId,
          ConcelhoDescription: this.objDTO.Sinistro.SinistroConcelhoDescription,
          FreguesiaId: this.objDTO.Sinistro.SinistroFreguesiaId,
          FreguesiaDescription: this.objDTO.Sinistro.SinistroFreguesiaDescription,
          Obs: this.objDTO.Sinistro.SinistroObs || ''
        });

        this.$forceUpdate();
      },

      /**
       * Trata a mudança de unidade de risco, carregando objetos segurados relacionados
       */
      async handleRiskUnitChange() {
        // Limpar dados dependentes
        this.objDTO.Apolice.ObjectoSeguradoExternalId = null;
        this.objDTO.Apolice.ApoliceCoberturaId = null;
        this.insuranceObjects = [];
        this.coverages = [];

        // Carregar objetos segurados para a unidade de risco selecionada
        if (this.objDTO.Apolice.UnidadeDeRiscoExternalId && this.objDTO.Apolice.ApoliceContrato) {
          this.loading.objectosSegurados = true;
          try {
            // Verificar se temos os parâmetros necessários
            if (
              !this.objDTO.Apolice.ApoliceContrato ||
              !this.objDTO.Apolice.UnidadeDeRiscoExternalId
            ) {
              this.trataErro(
                new Error('Faltam parâmetros para buscar objetos segurados'),
                'validação',
                {
                  apoliceContrato: this.objDTO.Apolice.ApoliceContrato,
                  unidadeRiscoId: this.objDTO.Apolice.UnidadeDeRiscoExternalId
                }
              );
              this.insuranceObjects = [];
              return;
            }

            // Chamar getInsuranceObjects com ambos os parâmetros necessários
            const insuranceObjs = await getInsuranceObjects(
              this.objDTO.Apolice.ApoliceContrato,
              this.objDTO.Apolice.UnidadeDeRiscoExternalId
            );

            if (insuranceObjs && insuranceObjs.InsuranceObjects) {
              this.insuranceObjects = insuranceObjs.InsuranceObjects;
            } else {
              this.trataErro(
                new Error('Resposta vazia ou inválida ao buscar objetos segurados'),
                'processar resposta',
                { resposta: insuranceObjs }
              );
              this.insuranceObjects = [];
            }
          } catch (error) {
            this.trataErro(error, 'carregar objetos segurados', {
              apoliceContrato: this.objDTO.Apolice.ApoliceContrato,
              unidadeRisco: this.objDTO.Apolice.UnidadeDeRiscoExternalId
            });
            this.insuranceObjects = [];
          } finally {
            this.loading.objectosSegurados = false;
          }
        }
      },

      /**
       * Trata a mudança de objeto segurado, carregando coberturas relacionadas
       */
      async handleInsuranceObjectChange() {
        // Limpar dados dependentes
        this.objDTO.Apolice.ApoliceCoberturaId = null;
        this.coverages = [];

        // Carregar coberturas para o objeto segurado selecionado
        if (this.objDTO.Apolice.ApoliceContrato && this.objDTO.Apolice.ObjectoSeguradoExternalId) {
          this.loading.coverages = true;
          try {
            const coveragesData = await getCoverages(
              this.objDTO.Apolice.ApoliceContrato,
              this.objDTO.Apolice.ObjectoSeguradoExternalId
            );

            if (coveragesData && Array.isArray(coveragesData)) {
              this.coverages = coveragesData;

              // Se houver apenas uma cobertura, selecione-a automaticamente
              if (this.coverages.length === 1) {
                await this.selecionarCobertura(this.coverages[0].CoverageId);
              }
            } else {
              this.trataErro(
                new Error('Resposta inválida ao buscar coberturas'),
                'processar coberturas',
                { resposta: coveragesData }
              );
              this.coverages = [];
            }
          } catch (error) {
            this.trataErro(error, 'carregar coberturas', {
              apoliceContrato: this.objDTO.Apolice.ApoliceContrato,
              objetoSegurado: this.objDTO.Apolice.ObjectoSeguradoExternalId
            });
            this.coverages = [];
          } finally {
            this.loading.coverages = false;
          }
        }
      },

      /**
       * Seleciona uma cobertura garantindo valor seguro para Int32
       * @param {string|number} coverageId - ID da cobertura a selecionar
       */
      async selecionarCobertura(coverageId) {
        const numValue = Number(coverageId);

        if (numValue > MAX_INT32) {
          this.trataErro(
            new Error(`Coverage ID ${coverageId} excede o valor máximo de Int32`),
            'selecionar cobertura',
            { coverageId }
          );
          this.$set(this.objDTO.Apolice, 'ApoliceCoberturaId', '1');
        } else {
          this.$set(this.objDTO.Apolice, 'ApoliceCoberturaId', String(numValue));
        }

        await this.handleCoverageChange();
      },

      /**
       * Trata a mudança de cobertura, carregando eventos relacionados
       */
      async handleCoverageChange() {
        // Limpar dados dependentes
        this.objDTO.Sinistro.SinistroNaturezaEventoId = null;
        this.events = [];

        // Garantir segurança do ApoliceCoberturaId para evitar erros de Int32
        this.garantirValorSeguroApoliceCoberturaId();

        // Carregar eventos para a cobertura selecionada ou pelo ID do produto
        if (this.objDTO.Apolice.ApoliceProdutoId) {
          this.loading.events = true;

          try {
            // Log de contexto para diagnóstico
            const contexto = {
              apoliceProdutoId: this.objDTO.Apolice.ApoliceProdutoId,
              apoliceCoberturaId: this.objDTO.Apolice.ApoliceCoberturaId,
              ramoId: this.objDTO.Sinistro.SinistroRamoId
            };

            // Usar o método getEvents melhorado que priorizará getEventsByProductId
            const eventData = await getEvents(
              contexto.apoliceProdutoId,
              contexto.apoliceCoberturaId,
              contexto.ramoId
            );

            this.processarEventosRecebidos(eventData);
          } catch (error) {
            this.trataErro(error, 'carregar eventos para cobertura', {
              cobertura: this.objDTO.Apolice.ApoliceCoberturaId,
              apoliceProdutoId: this.objDTO.Apolice.ApoliceProdutoId
            });
            this.events = [];
          } finally {
            this.loading.events = false;
          }
        }
      },

      /**
       * Processa os eventos recebidos da API e aplica transformações necessárias
       * @param {Array|Object} eventDataOriginal - Dados de eventos recebidos
       */
      processarEventosRecebidos(eventDataOriginal) {
        // Verificar e garantir que events seja um array
        if (eventDataOriginal) {
          let eventDataProcessado = eventDataOriginal;

          if (!Array.isArray(eventDataProcessado)) {
            this.trataErro(
              new Error('Formato inválido de eventos recebidos'),
              'processar eventos',
              { eventData: eventDataProcessado }
            );

            if (eventDataProcessado.length !== undefined) {
              eventDataProcessado = Array.from(eventDataProcessado);
            } else {
              eventDataProcessado = [];
            }
          }

          // Garantir que cada evento tenha Id como string para evitar problemas de Int32 no backend
          this.events = eventDataProcessado.map(evento => {
            return {
              ...evento,
              Id: String(evento.Id), // força para string para evitar problemas de Int32
              Description: evento.Description || evento.description || ''
            };
          });

          // Se houver apenas um evento, selecione-o automaticamente
          if (this.events.length === 1) {
            this.$set(this.objDTO.Sinistro, 'SinistroNaturezaEventoId', this.events[0].Id);

            // Força a reavaliação da validação
            this.$nextTick(() => {
              if (this.$v && this.$v.objDTO && this.$v.objDTO.Sinistro) {
                this.$v.objDTO.Sinistro.SinistroNaturezaEventoId.$touch();
                this.$v.$touch();
              }
            });
          }
        } else {
          this.events = [];
        }
      },

      /**
       * Garante que ApoliceCoberturaId esteja em um formato seguro para Int32
       */
      garantirValorSeguroApoliceCoberturaId() {
        if (this.objDTO.Apolice.ApoliceCoberturaId) {
          const coverageId = this.objDTO.Apolice.ApoliceCoberturaId;
          const numValue = Number(coverageId);

          if (numValue > MAX_INT32) {
            this.trataErro(
              new Error(`ApoliceCoberturaId ${coverageId} excede o valor máximo de Int32`),
              'validar cobertura',
              { coverageId }
            );
            this.$set(this.objDTO.Apolice, 'ApoliceCoberturaId', '1');
          } else {
            // Garantir que seja armazenado como string para evitar problemas de conversão
            this.$set(this.objDTO.Apolice, 'ApoliceCoberturaId', String(coverageId));
          }
        }
      },

      /**
       * Carrega dados da apólice a partir do operationPK
       * @param {string} operationPK - Identificador da operação
       * @returns {Promise<void>}
       */
      async policySelected(operationPK) {
        if (!operationPK) {
          this.trataErro(new Error('operationPK não fornecido'), 'seleção de apólice', {}, false);
          return;
        }

        window.scrollTo(0, 0);
        this.loading.apoliceData = true;

        try {
          // Tenta obter os dados do formulário
          const formData = await getFormDataByApoliceProdutoIdAndBranchId(
            this.objDTO.Apolice.ApoliceProdutoId,
            this.objDTO.Apolice.ApoliceCoberturaId
          );

          // Verifica se formData existe antes de acessar propriedades
          if (formData && formData.Id) {
            this.currentAvisoId = formData.Id;
            this.formName = formData.Description || FORM_NAME;
            this.objDTO.FormAvisoId = formData.Id;
          } else {
            // Usa valores padrão caso formData seja null ou não tenha Id
            this.currentAvisoId = DEFAULT_AVISO_ID;
            this.formName = FORM_NAME;
            this.objDTO.FormAvisoId = DEFAULT_AVISO_ID;
          }

          const {
            riskUnit,
            riskUnits,
            insuranceObject,
            insuranceObjects,
            coverage,
            coverages,
            events
          } = await getInfoByOperationPK(
            operationPK,
            this.objDTO.Apolice.ApoliceProdutoId,
            this.objDTO.Sinistro.SinistroRamoId
          );

          // Garantir que todos os dados recebidos são arrays
          if (!events || !Array.isArray(events) || events.length === 0) {
            try {
              const eventsByProductId = await getEventsByProductId(
                this.objDTO.Apolice.ApoliceProdutoId
              );
              this.events = Array.isArray(eventsByProductId) ? eventsByProductId : [];
            } catch (error) {
              this.trataErro(
                error,
                'obter eventos alternativos',
                {
                  apoliceProdutoId: this.objDTO.Apolice.ApoliceProdutoId
                },
                false
              );
              this.events = [];
            }
          } else {
            this.events = Array.isArray(events) ? events : [];
          }

          this.objDTO.Apolice.UnidadeDeRiscoExternalId = riskUnit;
          this.objDTO.Apolice.ObjectoSeguradoExternalId = insuranceObject;
          this.objDTO.Apolice.ApoliceCoberturaId = coverage;
          this.riskUnits = Array.isArray(riskUnits) ? riskUnits : [];
          this.insuranceObjects = Array.isArray(
            insuranceObjects && insuranceObjects.InsuranceObjects
          )
            ? insuranceObjects.InsuranceObjects
            : [];
          this.coverages = Array.isArray(coverages) ? coverages : [];
        } catch (error) {
          this.trataErro(error, 'carregar dados da apólice', { operationPK }, false);

          // Em caso de erro, usa valores padrão
          this.currentAvisoId = DEFAULT_AVISO_ID;
          this.formName = FORM_NAME;
          this.objDTO.FormAvisoId = DEFAULT_AVISO_ID;
        } finally {
          this.loading.apoliceData = false;
        }
      },

      /**
       * Tratamento padronizado de erros com logs estruturados
       * @param {Error} error - O erro capturado
       * @param {string} operacao - Nome da operação que falhou
       * @param {Object} dadosContexto - Dados adicionais de contexto
       * @param {boolean} exibirAlerta - Se deve exibir alerta ao usuário
       */
      trataErro(error, operacao, dadosContexto = {}, exibirAlerta = false) {
        // Estrutura o log de erro com contexto
        const contextoLog = {
          operacao,
          ...dadosContexto,
          mensagem: error.message || 'Erro desconhecido',
          stack: error.stack
        };

        // Log estruturado no console
        console.error(`Erro na operação ${operacao}:`, contextoLog);

        // Exibe alerta ao usuário apenas se solicitado
        if (exibirAlerta) {
          Swal.fire({
            title: 'Erro',
            text: `Ocorreu um erro ao ${operacao}. Por favor, tente novamente.`,
            icon: 'error',
            confirmButtonText: 'Ok'
          });
        }
      },

      /**
       * Trata a mudança de natureza do sinistro (evento)
       */
      onNaturezaChange() {
        // Implementar lógica específica para mudança de natureza se necessário
      },

      /**
       * Trata a mudança de cobertura, atualizando a natureza do sinistro
       */
      handleCoberturaDropdownSelection() {
        // Chama o método de mudança de cobertura para carregar eventos relacionados
        this.handleCoverageChange();
      }
    }
  };
</script>

<style>
  .textAlignCenter {
    text-align: center;
  }
</style>
